import { useRef } from 'react';
import { leaveRoom } from '../services/GameService';
import { getErrorMessage } from '../services/ApiError';

// Called only after the page's removal confirmation. The authorized HTTP
// endpoint owns removal and target-device notifications; the host must not
// invoke the target player's connection-only hub LeaveRoom method.
export const useRoomPlayerRemoval = ({ roomId, playerId, isHost, targetPlayerId,
    setLoading, setShowRemoveDialog, setErrorMessage, onRemoved, fallbackError, translateError }) => {
    const pending = useRef(false);
    return async () => {
        if (pending.current || !isHost || !targetPlayerId || targetPlayerId === playerId) return;
        pending.current = true;
        setLoading(true);
        setShowRemoveDialog(false);
        try {
            await leaveRoom(roomId, targetPlayerId);
            onRemoved();
        } catch (error) {
            setErrorMessage(translateError ? translateError(error, fallbackError) : getErrorMessage(error, fallbackError));
        } finally {
            pending.current = false;
            setLoading(false);
        }
    };
};
